/*
 * @Author: zhangjingqing
 * @Date: 2022-04-02 18:40:22
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-01 17:09:12
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\utils\dict.js
 */
export const indexStandardType = [
  {
    label: "企业会计准则（2007）",
    value: '0',
  },
  {
    label: "企业会计准则（2019）",
    value: '1',
  },
  {
    label: "小企业会计准则（2013）",
    value: '2',
  },
];

export const period = [
    {
        label: "一年",
        value: '1',
    },
    {
        label: "两年",
        value: '2',
    },
    {
        label: "三年",
        value: '3',
    },
    {
        label: "四年",
        value: '4',
    },
    {
        label: "五年",
        value: '5',
    },
];

export const taxpayerNature = [
  {
    label: "一般纳税人",
    value: '0',
  },
  {
    label: "小规模纳税人",
    value: '1',
  },
];

export const dataType = [
  {
    label: "年",
    value: 0,
  },
  {
    label: "季",
    value: 1,
  },
  {
    label: "月",
    value: 2,
  },
];

export const indexLevel = [
  {
    label: "一级指标",
    value: 1,
  },
  {
    label: "二级指标",
    value: 2,
  },
];

export const riskType = [
  {
    label: "无",
    value: 0,
  },
  {
    label: "低",
    value: 1,
  },
  {
    label: "中",
    value: 2,
  },
  {
    label: "高",
    value: 3,
  },
];

export const industry = [
  {
    label: "制造业",
    value: '0',
  },
  {
    label: "批发和零售业",
    value: '1',
  },
  {
    label: "现代服务业",
    value: '2',
  },
  {
    label: "其他",
    value: '3',
  },
  {
    label: "农业",
    value: '01',
    },
   {
    label: "林业",
    value: '02',
    },
   {
    label: "畜牧业",
    value: '03',
   },  
    {
    label: "渔业",
    value: '04',
    },
   {
    label: "农、林、牧、渔专业及辅助性活动",
    value: '05',
    },
   {
    label: "煤炭开采和洗选业",
    value: '06',
   },  
    
    {
    label: "石油和天然气开采业",
    value: '07',
    },
   {
    label: "黑色金属矿采选业",
    value: '08',
    },
   {
    label: "有色金属矿采选业",
    value: '09',
   },  
    {
    label: "非金属矿采选业",
    value: 10,
    },
   {
    label: "开采专业及辅助性活动",
    value: 11,
    },
   {
    label: "其他采矿业",
    value: 12,
   },  
   {
    label: "农副食品加工业",
    value: 13,
    },
   {
    label: "食品制造业",
    value: 14,
    },
   {
    label: "酒、 饮料和精制茶制造业",
    value: 15,
   },  
    {
    label: "烟草制品业",
    value: 16,
    },
   {
    label: "纺织业",
    value: 17,
    },
   {
    label: "纺织服装、服饰业",
    value: 18,
   },  
  {
    label: "皮革、毛皮、羽毛及其制品和制鞋业",
    value: 19,
  },
   {
    label: "木材加工和木、竹、藤、棕、草制品业",
    value: 20,
    },
   {
    label: "家具制造业",
    value: 21,
   },  
    {
    label: "造纸和纸制品业",
    value: 22,
    },
   {
    label: "印刷和记录媒介复制业",
    value: 23,
    },
   {
    label: "文教、工美、体育和娱乐用品制造业",
    value: 24,
   },  
    
  {
    label: "石油、煤炭及其他燃料加工业",
    value: 25,
   }, 
  {
    label: "化学原料和化学制品制造业",
    value: 26,
   }, 
  {
    label: "医药制造业",
    value: 27,
   }, 
   {
    label: "化学纤维制造业",
    value: 28,
   }, 
   
    {
    label: "橡胶和塑料制品业",
    value: 29,
   }, 
    {
    label: "非金属矿物制品业",
    value: 30,
   },  
    {
    label: "黑色金属冶炼和压延加工业",
    value: 31,
   },  
  {
    label: "有色金属冶炼和压延加工业",
    value: 32,
   },    
   {
    label: "金属制品业",
    value: 33,
   }, 
   {
    label: "通用设备制造业",
    value: 34,
   }, 
   {
    label: "专用设备制造业",
    value: 35,
   }, 
   {
    label: "汽车制造业",
    value: 36,
   },  {
    label: "铁路、船舶、航空航天和其他运输设备制",
    value: 37,
   }, 
   {
    label: "电气机械和器材制造业",
    value: 38,
   },  
   {
    label: "计算机、通信和其他电子设备制造业",
    value: 39,
   },    
   {
    label: "仪器仪表制造业",
    value: 40,
   },
   {
    label: "其他制造业",
    value: 41,
   },
   {
    label: "废弃资源综合利用业",
    value: 42,
   },
   {
    label: "金属制品、机械和设备修理业",
    value: 43,
   }, 
   {
    label: "电力、热力生产和供应业",
    value: 44,
   }, 
   {
    label: "燃气生产和供应业",
    value: 45,
   }, 
   {
    label: "水的生产和供应业",
    value: 46,
   }, 
   {
    label: "房屋建筑业",
    value: 47,
   }, 
   {
    label: "土木工程建筑业",
    value: 48,
   }, 
   {
    label: "建筑安装业",
    value: 49,
   }, 
   {
    label: "建筑装饰、装修和其他建筑业",
    value: 50,
   },      
  {
    label: "批发业",
    value: 51,
   }, 
  {
    label: "零售业",
    value: 52,
   }, 
  {
    label: "铁路运输业",
    value: 53,
   }, 
  {
    label: "道路运输业",
    value: 54,
   }, 
  {
    label: "水上运输业",
    value: 55,
   }, 
  {
    label: "航空运输业",
    value: 56,
   }, 
  {
    label: "管道运输业",
    value: 57,
   },
  {
    label: "多式联运和运输代理业",
    value: 58,
   },
  {
    label: "装卸搬运和仓储业",
    value: 59,
   },
  {
    label: "邮政业",
    value: 60,
   },
  {
    label: "住宿业",
    value: 61,
   },
  {
    label: "餐饮业",
    value: 62,
   },
  {
    label: "电信、广播电视和卫星传输服务",
    value: 63,
   },
  {
    label: "互联网和相关服务",
    value: 64,
   },
  {
    label: "软件和信息技术服务业",
    value: 65,
   },
  {
    label: "货币金融服务",
    value: 66,
   },
  {
    label: "资本市场服务",
    value: 67,
   },
  {
    label: "保险业",
    value: 68,
   },
  {
    label: "其他金融业",
    value: 69,
   },
   {
    label: "房地产业",
    value: 70,
   }, 
   {
    label: "租赁业",
    value: 71,
   }, 
   {
    label: "商务服务业",
    value: 72,
   }, 
   {
    label: "研究和试验发展",
    value: 73,
   }, 
   {
    label: "专业技术服务业",
    value: 74,
   }, 
   {
    label: "科技推广和应用服务业",
    value: 75,
   }, 
   {
    label: "水利管理业",
    value: 76,
   },
   {
    label: "生态保护和环境治理业",
    value: 77,
   },  
   {
    label: "公共设施管理业",
    value: 78,
   },  
   {
    label: "土地管理业",
    value: 79,
   },  
   {
    label: "居民服务业",
    value: 80,
   },       
   {
    label: "机动车、电子产品和日用产品修理业",
    value: 81,
   },   
   {
    label: "其他服务业",
    value: 82,
   },   
   {
    label: "教育",
    value: 83,
   },    
  {
    label: "卫生",
    value: 84,
   },    
  {
    label: "社会工作",
    value: 85,
   },    
  {
    label: "新闻和出版业",
    value: 86,
   },    
  {
    label: "广播、电视、电影和录音制作业",
    value: 87,
   }, 
  {
    label: "文化艺术业",
    value: 88,
   }, 
  {
    label: "体育",
    value: 89,
   }, 
  {
    label: "娱乐业",
    value: 90,
   }, 
  {
    label: "中国共产党机关",
    value: 91,
   }, 
      
  {
    label: "国家机构",
    value: 92,
   }, 
  {
    label: "人民政协、民主党派",
    value: 93,
   }, 
  {
    label: "社会保障",
    value: 94,
   }, 
 {
    label: "群众团体、社会团体和其他成员组织",
    value: 95,
   }, 
   {
    label: "基层群众自治组织及其他组织",
    value: 96,
   },         
   {
    label: "国际组织",
    value: 97,
   },   
   {
    label: "农业",
    value: '农业',
    },
   {
    label: "林业",
    value: '林业',
    },
   {
    label: "畜牧业",
    value: '畜牧业',
   },  
    {
    label: "渔业",
    value: '渔业',
    },
   {
    label: "农、林、牧、渔专业及辅助性活动",
    value: '农、林、牧、渔专业及辅助性活动',
    },
   {
    label: "煤炭开采和洗选业",
    value: '煤炭开采和洗选业',
   },  
    
    {
    label: "石油和天然气开采业",
    value: '石油和天然气开采业',
    },
   {
    label: "黑色金属矿采选业",
    value: '黑色金属矿采选业',
    },
   {
    label: "有色金属矿采选业",
    value: '有色金属矿采选业',
   },  
    {
    label: "非金属矿采选业",
    value: '非金属矿采选业',
    },
   {
    label: "开采专业及辅助性活动",
    value: '开采专业及辅助性活动',
    },
   {
    label: "其他采矿业",
    value: '其他采矿业',
   },  
   {
    label: "农副食品加工业",
    value: '农副食品加工业',
    },
   {
    label: "食品制造业",
    value: '食品制造业',
    },
   {
    label: "酒、 饮料和精制茶制造业",
    value: '酒、 饮料和精制茶制造业',
   },  
    {
    label: "烟草制品业",
    value: '烟草制品业',
    },
   {
    label: "纺织业",
    value: '纺织业',
    },
   {
    label: "纺织服装、服饰业",
    value: '纺织服装、服饰业',
   },  
  {
    label: "皮革、毛皮、羽毛及其制品和制鞋业",
    value: '皮革、毛皮、羽毛及其制品和制鞋业',
  },
   {
    label: "木材加工和木、竹、藤、棕、草制品业",
    value: '木材加工和木、竹、藤、棕、草制品业',
    },
   {
    label: "家具制造业",
    value: '家具制造业',
   },  
    {
    label: "造纸和纸制品业",
    value: '造纸和纸制品业',
    },
   {
    label: "印刷和记录媒介复制业",
    value: '印刷和记录媒介复制业',
    },
   {
    label: "文教、工美、体育和娱乐用品制造业",
    value: '文教、工美、体育和娱乐用品制造业',
   },  
    
  {
    label: "石油、煤炭及其他燃料加工业",
    value: '石油、煤炭及其他燃料加工业',
   }, 
  {
    label: "化学原料和化学制品制造业",
    value: '化学原料和化学制品制造业',
   }, 
  {
    label: "医药制造业",
    value: '医药制造业',
   }, 
   {
    label: "化学纤维制造业",
    value: '化学纤维制造业',
   }, 
   
    {
    label: "橡胶和塑料制品业",
    value: '橡胶和塑料制品业',
   }, 
    {
    label: "非金属矿物制品业",
    value: '非金属矿物制品业',
   },  
    {
    label: "黑色金属冶炼和压延加工业",
    value: '黑色金属冶炼和压延加工业',
   },  
  {
    label: "有色金属冶炼和压延加工业",
    value: '有色金属冶炼和压延加工业',
   },    
   {
    label: "金属制品业",
    value: '金属制品业',
   }, 
   {
    label: "通用设备制造业",
    value: '通用设备制造业',
   }, 
   {
    label: "专用设备制造业",
    value: '专用设备制造业',
   }, 
   {
    label: "汽车制造业",
    value: '汽车制造业',
   },  {
    label: "铁路、船舶、航空航天和其他运输设备制",
    value: '铁路、船舶、航空航天和其他运输设备制',
   }, 
   {
    label: "电气机械和器材制造业",
    value: '电气机械和器材制造业',
   },  
   {
    label: "计算机、通信和其他电子设备制造业",
    value: '计算机、通信和其他电子设备制造业',
   },    
   {
    label: "仪器仪表制造业",
    value: '仪器仪表制造业',
   },
   {
    label: "其他制造业",
    value: '其他制造业',
   },
   {
    label: "废弃资源综合利用业",
    value: '废弃资源综合利用业',
   },
   {
    label: "金属制品、机械和设备修理业",
    value: '金属制品、机械和设备修理业',
   }, 
   {
    label: "电力、热力生产和供应业",
    value: '电力、热力生产和供应业',
   }, 
   {
    label: "燃气生产和供应业",
    value: '燃气生产和供应业',
   }, 
   {
    label: "水的生产和供应业",
    value: '水的生产和供应业',
   }, 
   {
    label: "房屋建筑业",
    value: '房屋建筑业',
   }, 
   {
    label: "土木工程建筑业",
    value: '土木工程建筑业',
   }, 
   {
    label: "建筑安装业",
    value: '建筑安装业',
   }, 
   {
    label: "建筑装饰、装修和其他建筑业",
    value: '建筑装饰、装修和其他建筑业',
   },      
  {
    label: "批发业",
    value: '批发业',
   }, 
  {
    label: "零售业",
    value: '零售业',
   }, 
  {
    label: "铁路运输业",
    value: '铁路运输业',
   }, 
  {
    label: "道路运输业",
    value: '道路运输业',
   }, 
  {
    label: "水上运输业",
    value: '水上运输业',
   }, 
  {
    label: "航空运输业",
    value: '航空运输业',
   }, 
  {
    label: "管道运输业",
    value: '管道运输业',
   },
  {
    label: "多式联运和运输代理业",
    value: '多式联运和运输代理业',
   },
  {
    label: "装卸搬运和仓储业",
    value: '装卸搬运和仓储业',
   },
  {
    label: "邮政业",
    value: '邮政业',
   },
  {
    label: "住宿业",
    value: '住宿业',
   },
  {
    label: "餐饮业",
    value: '餐饮业',
   },
  {
    label: "电信、广播电视和卫星传输服务",
    value: '电信、广播电视和卫星传输服务',
   },
  {
    label: "互联网和相关服务",
    value: '互联网和相关服务',
   },
  {
    label: "软件和信息技术服务业",
    value: '软件和信息技术服务业',
   },
  {
    label: "货币金融服务",
    value: '货币金融服务',
   },
  {
    label: "资本市场服务",
    value: '资本市场服务',
   },
  {
    label: "保险业",
    value: '保险业',
   },
  {
    label: "其他金融业",
    value: '其他金融业',
   },
   {
    label: "房地产业",
    value: '房地产业',
   }, 
   {
    label: "租赁业",
    value: '租赁业',
   }, 
   {
    label: "商务服务业",
    value: '商务服务业',
   }, 
   {
    label: "研究和试验发展",
    value: '研究和试验发展',
   }, 
   {
    label: "专业技术服务业",
    value: '专业技术服务业',
   }, 
   {
    label: "科技推广和应用服务业",
    value: '科技推广和应用服务业',
   }, 
   {
    label: "水利管理业",
    value: '水利管理业',
   },
   {
    label: "生态保护和环境治理业",
    value: '生态保护和环境治理业',
   },  
   {
    label: "公共设施管理业",
    value: '公共设施管理业',
   },  
   {
    label: "土地管理业",
    value: '土地管理业',
   },  
   {
    label: "居民服务业",
    value: '居民服务业',
   },       
   {
    label: "机动车、电子产品和日用产品修理业",
    value: '机动车、电子产品和日用产品修理业',
   },   
   {
    label: "其他服务业",
    value: '其他服务业',
   },   
   {
    label: "教育",
    value: '教育',
   },    
  {
    label: "卫生",
    value: '卫生',
   },    
  {
    label: "社会工作",
    value: '社会工作',
   },    
  {
    label: "新闻和出版业",
    value: '新闻和出版业',
   },    
  {
    label: "广播、电视、电影和录音制作业",
    value: '广播、电视、电影和录音制作业',
   }, 
  {
    label: "文化艺术业",
    value: '文化艺术业',
   }, 
  {
    label: "体育",
    value: '体育',
   }, 
  {
    label: "娱乐业",
    value: '娱乐业',
   }, 
  {
    label: "中国共产党机关",
    value: '中国共产党机关',
   }, 
      
  {
    label: "国家机构",
    value: '国家机构',
   }, 
  {
    label: "人民政协、民主党派",
    value: '人民政协、民主党派',
   }, 
  {
    label: "社会保障",
    value: '社会保障',
   }, 
 {
    label: "群众团体、社会团体和其他成员组织",
    value: '群众团体、社会团体和其他成员组织',
   }, 
   {
    label: "基层群众自治组织及其他组织",
    value: '基层群众自治组织及其他组织',
   },         
   {
    label: "国际组织",
    value: '国际组织',
   },               
   
];

export const registrationType = [
  {
    label: "有限责任公司",
    value: '0',
  },
  {
    label: "股份有限公司",
    value: '1',
  },
  {
    label: "其他",
    value: '2',
  },
];
